import { render, staticRenderFns } from "./CourseForm.vue?vue&type=template&id=4e793cd6"
import script from "./CourseForm.vue?vue&type=script&lang=js"
export * from "./CourseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports